import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import ShoppingCart from './utils/ShoppingCart';

const hbPriceId = process.env.REACT_APP_STRIPE_PRICE_ID_HADABOT_BASE_KIT;
const hb50OffPriceId =
  process.env.REACT_APP_STRIPE_PRICE_ID_HADABOT_BASE_KIT__50_OFF;
const hb90OffPriceId =
  process.env.REACT_APP_STRIPE_PRICE_ID_HADABOT_BASE_KIT__90_OFF;

const hbAddOnSpeedSensorId =
  process.env.REACT_APP_STRIPE_PRICE_ID_HADABOT_ADD_ON_SPEED_SENSOR;
const hbAddOnRangeSensorsId =
  process.env.REACT_APP_STRIPE_PRICE_ID_HADABOT_ADD_ON_RANGE_SENSORS;

function AddToCartButton(props) {
  const [goToCart, setGoToCart] = useState(false);

  if (goToCart === true) {
    window.location.assign('/cart.html');
  }

  const productChart = {
    'hadabot-base-kit': {
      priceId: hbPriceId,
      pricePerStr: '99.95',
      description: 'Hadabot Turtle Base Kit',
    },
    'hadabot-base-kit-50-off': {
      priceId: hb50OffPriceId,
      pricePerStr: '50.00',
      description: 'Hadabot Turtle Base Kit - 50% off promo',
    },
    'hadabot-base-kit-90-off': {
      priceId: hb90OffPriceId,
      pricePerStr: '10.00',
      description: 'Hadabot Turtle Base Kit - 90% off promo',
    },

    'hadabot-add-on-speed-sensor': {
      priceId: hbAddOnSpeedSensorId,
      pricePerStr: '49.95',
      description: 'Hadabot Add-On: Motor + Speed Sensor',
    },

    'hadabot-add-on-range-sensors': {
      priceId: hbAddOnRangeSensorsId,
      pricePerStr: '79.95',
      description: 'Hadabot Add-On: Range Sensors',
    },
  };
  let prod = null;
  const { itemSlug } = props;
  prod = productChart[itemSlug];

  if (prod === null) {
    return <div />;
  }

  function handleClick() {
    const sc = new ShoppingCart();
    sc.setItem(prod.priceId, 1, parseFloat(prod.pricePerStr), prod.description);
    sc.saveCart();

    window.mixpanel.track('button', { name: 'add_to_cart', action: 'click' });

    setGoToCart(true);
  }

  return (
    <div>
      <Button variant="primary" onClick={() => handleClick(prod)} block>
        {`Add To Cart - $${prod.pricePerStr}`}
      </Button>
    </div>
  );
}

AddToCartButton.propTypes = {
  itemSlug: PropTypes.string.isRequired,
};

export default AddToCartButton;
